export default function StatCard({ label, value, hint, tid }) {
  return (
    <div
      data-testid={tid}
      className="cre-surface p-5 md:p-6 rounded-sm"
    >
      <div className="cre-overline">{label}</div>
      <div className="mt-2 font-heading text-3xl md:text-4xl font-black tracking-tight">
        {value}
      </div>
      {hint ? (
        <div className="mt-1 text-xs text-zinc-500">{hint}</div>
      ) : null}
    </div>
  );
}
